// metaConfig.js
const metaConfig = {
  "Softwood": {
    title: "Softwood Decking & Black Guttering | High-Quality Building Materials",
    description:
      "Shop softwood decking and black guttering near me at W-Hanson. Durable, weather-resistant materials perfect for outdoor projects. Order now for top-quality supplies!",
    keywords: "softwood decking, black guttering near me, softwood decking boards, treated softwood, decking timber, black guttering, guttering suppliers near me, timber decking",
  },
  "Firrings-Arris-Featheredge-Fencing": {
    title: "Firrings, Arris Rails & Featheredge Fencing | W-hanson UK",
    description:
      "Shop firrings, arris rails, and featheredge fencing at W-hanson UK. Quality fencing supplies for all your outdoor projects. Reliable, durable, and ready to use!",
    keywords: "softwood suppliers",
  },
  "Thermowood": {
    title: "Discover Premium Thermowood: Buy Now for Sustainable Construction",
    description:
      "Get this durable and sustainable Thermowood at W-Hanson UK. Enhance your projects with high-quality timber. Buy now for long-lasting performance.",
    keywords: "white softwood",
  },
  "C24-softwood-treated-PEFC": {
    title: "C24 Treated Joist & Treated Sleepers | High-Quality Structural Timber",
    description:
      "Get premium C24 treated joist and treated sleepers at W-Hanson. Perfect for structural and landscaping projects, our timber is durable and PEFC-certified. Order now!",
    keywords: "C24 treated joist, treated sleepers, C24 timber, structural timber, PEFC certified timber, treated joist for construction, landscaping sleepers",
  },
  "Cheshire-Mouldings": {
    title: "Explore Cheshire Mouldings Collection: Get Premium Mouldings Now",
    description:
      "Discover exquisite Cheshire mouldings at W-Hanson UK. Elevate your space with our premium selection. Buy now for timeless elegance and quality craftsmanship.",
    keywords: "softwood timber",
  },
  "home-grown-eased-edge-kd-treated": {
    title: "High-Quality C16 Treated Softwood | Durable & Reliable Timber",
    description:
      "Shop C16 treated softwood at W-Hanson for durable and reliable timber solutions. Ideal for construction, framing, and structural applications. Order today!",
    keywords: "C16 treated softwood, treated softwood timber, C16 timber, softwood for construction, C16 graded timber, structural timber",
  },
  CLS: {
    title: "Discover Versatile CLS Timber: Buy Now for Your Construction Needs",
    description:
      "Get this high-quality CLS timber at W-Hanson UK. Perfect for various construction projects. Buy now and enhance your building endeavors.",
    keywords: "",
  },
  "PAR-Contract-Softwood": {
    title: "Discover High-Quality PAR Softwood: Buy Now for Your Projects",
    description:
      "Get this premium PAR contract softwood at W-Hanson UK. Enhance your projects with top-quality timber. Buy now for reliable and durable construction materials.",
    keywords: "",
  },
  "PAR-European-Softwood": {
    title: "Buy Premium PAR European Softwood: Enhance Your Projects Today!",
    description:
      "Discover high-quality PAR European Softwood at W-Hanson UK. Get this top-grade timber now to elevate your construction projects. Buy now for unbeatable quality and performance.",
    keywords: "",
  },
  "PAR-European-Softwood": {
    title: "Enhance Your Spaces with PAR European Softwood Mouldings: Buy Now!",
    description:
      "Discover exquisite PAR European Softwood Mouldings at W-Hanson UK. Get this premium quality for your projects today. Buy now to elevate your interior design.",
    keywords: "",
  },
  "PAR-European-Softwood-Mouldings": {
    title: "Enhance Your Spaces with PAR European Softwood Mouldings: Buy Now!",
    description:
      "Discover exquisite PAR European Softwood Mouldings at W-Hanson UK. Get this premium quality for your projects today. Buy now to elevate your interior design.",
    keywords: "",
  },
  "pointed-pegs": {
    title: "Buy Pointed Pegs for Secure Construction Projects at W-Hanson UK",
    description:
      "Discover high-quality pointed pegs at W-Hanson UK. Get this essential construction material now for secure and reliable building projects.",
    keywords: "",
  },
  "sash-materials": {
    title: "Enhance Your Sash Projects: Get Quality Materials Now",
    description:
      "Discover top-notch sash materials at W-Hanson UK. Buy now to elevate your projects with durable and reliable materials.",
    keywords: "",
  },
  "shrinkwrapped-door-linings": {
    title: "Get Shrinkwrapped Door Linings for Easy Installation",
    description:
      "Discover hassle-free installation with our shrinkwrapped door linings. Buy now and streamline your construction projects.",
    keywords: "Shrinkwrapped Door Linings",
  },
  "MDF-Mouldings": {
    title: "MDF Mouldings London |Buy Premium MDF Architrave & More",
    description:
      "London's trusted MDF mouldings supplier. Browse architrave, skirting, dado rails & more. High-quality, pre-primed & delivered. Trade prices.",
    keywords: "decorative MDF trim, MDF skirting board, pre-primed MDF, moisture resistant MDF mouldings",
  },
  "MDF-Skirting-Archtrave": {
    title: "MDF Skirting & Architrave Suppliers | Best Price & Quality",
    description:
      "Top-rated MDF architrave suppliers. Get the best MDF skirting board price without compromising on quality. Pre-primed, all profiles. UK-wide delivery.",
    keywords: "skirting and architrave sets, interior trim, primed MDF skirting, period property mouldings",
  },
  "MDF-Window-Boards": {
    title: "Enhance Your Windows with MDF Window Boards – Buy Now!",
    description:
      "Discover premium MDF window boards at W-Hanson UK. Get this durable solution for your windows. Buy now to upgrade your home!",
    keywords: "mdf skirting mouldings",
  },
  "MDF-Door-Stop-Misc": {
    title: "Premium MDF Door Linings in London | High-Quality MDF Door Stops",
    description:
      "Looking for MDF door linings in London? W-Hanson offers high-quality MDF door stops and linings for a seamless finish. Browse our premium selection and order today!",
    keywords: "MDF door linings London, MDF door stops, MDF door frames, MDF door linings suppliers, MDF interior door linings",
  },
  "MDF-Linings-sets": {
    title: "Find Premium MDF Skirting Boards Near You | W-Hanson UK",
    description:
      "Discover top-quality MDF timber mouldings at W-Hanson UK. Get this durable and stylish MDF skirting board now. Buy now and enhance your interior designs.",
    keywords:
      "mdf skirting board near me,mdf timber mouldings,mdf moulding manufacturers",
  },
  Insulation: {
    title: "Discover Effective Cavity Insulation: Buy Now at W-Hanson UK",
    description:
      "Get this premium cavity insulation solution from W-Hanson UK. Enhance your property's energy efficiency and comfort. Buy now for insulation that lasts.",
    keywords: "cavity insulation",
  },
  Celotex: {
    title: "Buy Celotex Insulation: Upgrade Your Project with W-Hanson UK",
    description:
      "Discover high-quality Celotex insulation at W-Hanson UK. Get this top-notch insulation solution now to enhance your construction projects.",
    keywords: "",
  },
  Fibreglass: {
    title:
      "Discover Premium Fibreglass Products: Buy Now for Quality Construction",
    description:
      "Get this high-quality fibreglass from W-Hanson UK for your construction needs. Enhance durability and performance. Buy now for top-notch materials.",
    keywords: "",
  },
  "Cavity-Insulation": {
    title: "Discover Effective Cavity Insulation: Buy Now for Energy Savings",
    description:
      "Get this top-quality cavity insulation at W-Hanson UK. Improve your home's energy efficiency and comfort. Buy now for exceptional insulation solutions.",
    keywords: "",
  },
  Polystyrene: {
    title: "Discover Quality Polystyrene: Buy Now for Insulation Solutions",
    description:
      "Get this high-quality polystyrene insulation at W-Hanson UK. Enhance your projects with our durable solutions. Buy now for top-notch performance.",
    keywords: "",
  },
  "Sheet-Material": {
    title: "Sheet Materials Wholesale | High-Quality Timber Sheets at W-Hanson",
    description:
      "Looking for sheet materials wholesale? W-Hanson offers premium-quality timber sheets at competitive prices. Get top-grade plywood, MDF, and more for your projects. Order now!",
    keywords: "cheap plywood sheets, fire rated plywood, birch plywood, plywood sheets wholesale, affordable plywood, fire-resistant plywood",
  },
  "Birch-Plywood": {
    title: "Cheap Plywood Sheets & Fire Rated Plywood | Birch Plywood at W-Hanson",
    description:
      "Shop high-quality cheap plywood sheets and fire rated plywood at W-Hanson. Our birch plywood is durable, versatile, and ideal for all construction needs. Order today!",
    keywords: "cheap plywood sheets, fire rated plywood, birch plywood, plywood sheets wholesale, affordable plywood, fire-resistant plywood",
  },
  "Hardwood-Throughout-Plywood": {
    title: "Discover Premium Hardwood Plywood: Buy Now for Your Projects",
    description:
      "Get this high-quality hardwood plywood at W-Hanson UK. Enhance your projects with durable and reliable materials. Buy now for top-notch performance.",
    keywords: "birch plywood near me",
  },
  "Hardwood-Plywood-FSC": {
    title: "Top Hardwood Timber Merchants & Suppliers Near You | W-Hanson",
    description:
      "Looking for hardwood timber merchants near me? W-Hanson is your trusted hardwood timber suppliers near me, offering high-quality FSC-certified hardwood plywood. Order now!",
    keyword: "hardwood timber merchants near me, hardwood timber suppliers near me, FSC hardwood plywood, high-quality timber sheets, sustainable hardwood suppliers",
  },
  "Shuttering-Plywood": {
    title: "Quality Shuttering Plywood: Buy Now for Construction Needs",
    description:
      "Discover reliable shuttering plywood at W-Hanson UK. Get this top-grade material for your construction projects. Buy now for durability and performance.",
    keyword: "shuttering plywood",
  },
  "Marine-Plywood": {
    title: "Buy Marine Plywood for Quality Construction Projects",
    description:
      "Discover top-grade Marine Plywood at W-Hanson UK. Get this durable plywood now for your marine and construction needs. Buy now for premium quality.",
    keyword: "marine plywood",
  },
  OSB: {
    title: "Get OSB Panels for Your Projects at W-Hanson UK",
    description:
      "Discover top-quality OSB panels at W-Hanson UK. Buy now for durable construction materials. Get this essential building supply for your projects today!",
    keyword: "marine plywood near me",
  },
  MDF: {
    title: "Discover Premium MDF: Buy Now for Quality Projects",
    description:
      "Get this high-quality MDF at W-Hanson UK. Enhance your projects with durable and versatile materials. Buy now for top-notch results.",
    keyword: "",
  },
  "Moisture-Resistant-MDF": {
    title: "Discover Moisture-Resistant MDF: Buy Now for Durable Solutions",
    description:
      "Get this high-quality moisture-resistant MDF at W-Hanson UK. Enhance your projects with durable solutions. Buy now for reliable performance.",
    keyword: "",
  },
  "Chipboard": {
    title: "Discover Quality Chipboard at W-Hanson UK: Buy Now!",
    description:
      "Get this versatile chipboard for your construction needs at W-Hanson UK. Explore our range and buy now for reliable performance.",
    keyword: "",
  },
  "Hardboard": {
    title: "Discover Durable Hardboard: Buy Now for Your Projects",
    description:
      "Get this reliable hardboard from W-Hanson UK. Perfect for various applications. Buy now and enhance your construction projects.",
    keyword: "",
  },
  "Hardie-Backer": {
    title: "High-Quality Hardie Backer Boards: Buy Now from W-Hanson UK",
    description:
      "Discover top-grade Hardie Backer boards at W-Hanson UK. Get this essential construction material for your projects. Buy now for superior durability and performance.",
    keyword: "",
  },
  "Iron-On-Edging": {
    title: "Enhance Your Projects with Iron-On Edging: Buy Now!",
    description:
      "Discover high-quality iron-on edging at W-Hanson UK. Get this durable solution for your construction needs. Buy now for top-notch results.",
    keyword: "",
  },
  "Melamine-Faced-MDF": {
    title: "Buy High-Quality Melamine-Faced MDF at W-Hanson UK",
    description:
      "Discover top-quality Melamine-Faced MDF at W-Hanson UK. Get this durable material for your construction projects. Buy now for excellent results!",
    keyword: "",
  },
  "Flexcell": {
    title: "Enhance Your Projects with Flexcell: Buy Now at W-Hanson UK",
    description:
      "Discover the innovative Flexcell solution at W-Hanson UK. Get this versatile product now to elevate your construction projects.",
    keyword: "",
  },
  "Correx-Protection": {
    title: "Protect Your Surfaces with Correx: Buy Now at W-Hanson UK",
    description:
      "Discover high-quality Correx protection products at W-Hanson UK. Get this durable solution for safeguarding surfaces. Buy now for peace of mind.",
    keyword: "",
  },
  "Glues-Sealants-Chemicals": {
    title: "Shop Quality Glues, Sealants & Chemicals at W-Hanson UK",
    description:
      "Discover a wide range of glues, sealants, and chemicals at W-Hanson UK. Buy now to get top-quality products for your projects.",
    keyword: "glues sealants chemicals",
  },
  "CT1": {
    title: "Discover CT1 Adhesive: Buy Now for Reliable Bonding Solutions",
    description:
      "Get this top-quality adhesive from W-Hanson UK. Buy now for reliable bonding solutions and enhance your construction projects.",
    keyword: "",
  },
  "Evo-Stik": {
    title: "Get Evo-Stik Adhesives for Reliable Bonding | Buy Now",
    description:
      "Discover reliable Evo-Stik adhesives at W-Hanson UK. Get this trusted brand for all your bonding needs. Buy now for strong and durable results.",
    keyword: "",
  },
  "Bond-It": {
    title: "Buy Bond-It Adhesives: Secure Your Projects with W-Hanson UK",
    description:
      "Discover high-quality Bond-It adhesives at W-Hanson UK. Get this reliable solution now to ensure the durability of your projects. Buy now and experience the difference.",
    keyword: "",
  },
  "OB1": {
    title: "Get OB1: Buy Now for Premium Construction Solutions",
    description:
      "Discover OB1, the ultimate construction solution at W-Hanson UK. Get this premium product now for your building needs.",
    keyword: "",
  },
  "Metalwork": {
    title: "Discover Quality Metalwork at W-Hanson UK - Buy Now!",
    description:
      "Get this premium metalwork selection at W-Hanson UK. Explore our range and buy now for durable solutions to your construction needs.",
    keyword: "",
  },
  "Joist-Hangers": {
    title: "Buy Joist Hangers at W-Hanson UK for Secure Construction",
    description:
      "Discover a wide selection of joist hangers at W-Hanson UK. Get this essential hardware for your construction needs. Buy now and ensure secure building projects.",
    keyword: "joist hangers,buy joist hangers",
  },
  "Jiffy-Hangers": {
    title: "Buy Jiffy Hangers for Secure Installations at W-Hanson UK",
    description:
      "Discover reliable Jiffy Hangers at W-Hanson UK. Get this essential hardware for secure and efficient installations. Buy now for your construction needs.",
    keyword: "Jiffy Hangers",
  },
  "Beading": {
    title: "Shop Premium Beading: Buy Now at W-Hanson UK",
    description:
      "Discover top-quality beading options at W-Hanson UK. Get this essential accessory for your projects. Buy now for unbeatable quality and service.",
    keyword: "",
  },
  "Ties": {
    title:
      "Get Premium Ties for Construction Projects - Buy Now From W-Hanson Uk",
    description:
      "Discover a wide range of construction ties at W-Hanson UK. Enhance your projects with our durable and reliable ties. Buy now for quality you can trust.",
    keyword: "",
  },
  "Restraint-Straps": {
    title: "Secure Your Build: Restraint Straps Available Now",
    description:
      "Discover durable restraint straps at W-Hanson UK. Get this essential construction component now for added safety and stability. Buy now and secure your project.",
    keyword: "",
  },
  "Reinforcement-Mesh": {
    title: "Discover Quality Reinforcement Mesh: Buy Now from W-hanson UK",
    description:
      "Get this durable reinforcement mesh at W-Hanson UK. Strengthen your construction projects with our high-quality mesh. Buy now for reliable performance.",
    keyword: "",
  },
  "Metalwork-Misc": {
    title: "Quality Metalwork Accessories: Buy Now for Your Projects",
    description:
      "Discover a wide range of metalwork accessories at W-Hanson UK. Get this essential equipment for your construction needs. Buy now for reliable performance.",
    keyword: "",
  },
  "Aggregates-Heavyside": {
    title: "Shop Quality Aggregates & Heavyside Materials at W-Hanson UK",
    description:
      "Discover a wide range of aggregates and heavyside materials at W-Hanson UK. Get this essential supplies for your construction projects. Buy now for top-quality products and reliable service.",
    keyword: "aggregates,buy aggregates,aggregates near me,aggregate suppliers near me,aggregate stone near me",
  },
  "Bulk-Bags": {
    title: "Buy Bulk Bags: High-Quality Solutions at W-Hanson UK",
    description:
      "Discover versatile bulk bags at W-Hanson UK. Get this essential solution for your construction needs now. Order yours today for reliable performance.",
    keyword: "",
  },
  "Mini-Bags": {
    title: "Mini Bags- Buy Now for Convenient Building Solutions",
    description:
      "Discover versatile mini bags at W-Hanson UK. Get this convenient option for your building needs. Buy now for easy transportation and storage.",
    keyword: "",
  },
  "Cement": {
    title: "Buy Quality Cement at W-Hanson UK: Enhance Your Projects Today",
    description:
      "Discover top-grade cement for your construction needs at W-Hanson UK. Get this essential building material now and elevate your projects to the next level.",
    keyword: "buy cement,cement near me,",
  },
  "Top-Soil": {
    title: "Buy Quality Top Soil: Discover Rich Soil for Your Garden",
    description:
      "Get this nutrient-rich top soil at W-Hanson UK. Enhance your garden with our premium soil. Buy now for lush, healthy plants.",
    keyword: "top soil bulk bag",
  },
  "Air-Bricks": {
    title: "Buy Air Bricks for Ventilation: Enhance Your Space",
    description:
      "Discover a wide range of air bricks at W-Hanson UK. Get this essential ventilation solution now to improve airflow in your property.",
    keyword: "",
  },
  "Aco-Channel": {
    title: "Buy Aco Channel Drainage Systems Now from W-Hanson Uk",
    description:
      "Discover Aco Channel drainage systems at W-Hanson UK. Get this effective solution for water management. Buy now for reliable and durable drainage performance.",
    keyword: "",
  },
  "bricks": {
    title: "Buy Air Bricks Near Me at W-Hanson UK for Quality Construction",
    description:
      "Discover and buy now high-quality air bricks near me at W-Hanson UK. Get this essential building material for your construction needs today!",
    keyword: "air bricks near me",
  },
  "concrete-blocks": {
    title: "Buy Concrete Blocks Near Me: Quality Concrete Products Now",
    description:
      "Discover top concrete blocks and products at W-Hanson UK. Get this durable concrete near me for your projects. Buy now for quality you can trust.",
    keyword: "Concrete Blocks,concrete near me,concrete products",
  },
  "lightweight-blocks": {
    title: "Buy Lightweight Blocks Now for Your Construction Needs",
    description:
      "Discover lightweight blocks at W-Hanson UK. Get this essential building material for your projects. Buy now for quality and reliability in every block.",
    keyword: "concrete blocks near me,Lightweight Blocks",
  },
  "Fixings": {
    title: "Discover Top Fixings for Projects Buy Now at W-Hanson UK",
    description:
      "Get this wide range of fixings at W-Hanson UK. Discover top-quality products for your construction needs. Buy now for reliable and durable performance.",
    keyword: "",
  },
  "Timco-Bags": {
    title: "Discover Timco Bags at W-Hanson UK Buy Now for Quality",
    description:
      "Get this high-quality Timco Bags at W-Hanson UK. Buy now and discover durable bags for all your building needs. Perfect for construction projects.",
    keyword: "",
  },
  "Timco-Coach-Bolts": {
    title: "Discover Quality Timco Coach Bolts for Your Projects",
    description:
      "Get this premium Timco Coach Bolts at W-Hanson UK. Perfect for your construction needs. Discover durable and reliable fasteners. Shop now for quality you can trust.",
    keyword: "",
  },
  "Samac-Screws": {
    title: "Buy Samac Screws for All Projects at W-Hanson UK",
    description:
      "Get this high-quality Samac screws at W-Hanson UK for your construction needs. Discover durable and reliable screws for all your projects. Shop now!",
    keyword: "samac screws",
  },
  "Drywall-Screws": {
    title: "Discover Top-Quality Drywall Screws for Your Projects",
    description:
      "Get this premium selection of drywall screws at W-Hanson UK. Ideal for all your construction needs. Find reliable and durable fasteners for perfect results.",
    keyword: "Drywall Screws",
  },
  "Studding": {
    title: "Explore Quality Studding at W-Hanson UK - Discover Now!",
    description:
      "Get this essential studding material from W-Hanson UK. Explore our range and find the perfect fit for your construction needs.",
    keyword: "",
  },
  "Plasterboard-Rawlplug-Fixings": {
    title: "Find Plasterboard Rawlplug Fixings at W-Hanson UK",
    description:
      "Explore a variety of plasterboard rawlplug fixings at W-Hanson UK. Enhance your construction projects with these essential supplies.",
    keyword: "plasterboard fixings,",
  },
  "Masonry-Nails": {
    title: "Find High-Quality Masonry Nails at W-Hanson UK",
    description:
      "Explore durable masonry nails at W-Hanson UK. Enhance your projects with these reliable construction supplies.",
    keyword: "Masonry Nails",
  },
  "Misc-Fixings-Ironmongery": {
    title: "Shop Diverse Ironmongery & Misc Fixings at W-Hanson UK",
    description:
      "Explore a wide range of ironmongery and miscellaneous fixings at W-Hanson UK. Find quality products for all your construction needs.",
    keyword: "",
  },
  "TIMco-Firmahold": {
    title: "Find TIMco Firmahold Screws & Fasteners at W-Hanson UK",
    description:
      "Discover a range of TIMco Firmahold fasteners at W-Hanson UK. Find reliable solutions for your construction and DIY projects.",
    keyword: "",
  },
  "TIMco-Nails": {
    title: "Get Quality TIMco Nails for Secure Construction | W-Hanson UK",
    description:
      "Shop TIMco nails at W-Hanson UK for dependable fasteners tailored to meet your construction requirements.",
    keyword: "",
  },
  "TIMco-Screws": {
    title: "High-Quality TIMco Screws Available at W-Hanson UK",
    description:
      "Discover a wide range of TIMco screws at W-Hanson UK. From wood screws to specialist fasteners, find the perfect solution for your project.",
    keyword: "",
  },
  "TIMco-Shield-Protective-Film": {
    title: "Quality TIMco Shield Protective Film at W-Hanson UK",
    description:
      "Discover high-quality TIMco Shield Protective Film at W-Hanson UK. Protect your surfaces with durable, reliable solutions.",
    keyword: "",
  },
  "TIMco-Cutting": {
    title: "Precision TIMco Cutting Tools at W-Hanson UK",
    description:
      "Discover high-quality TIMco cutting tools at W-Hanson UK. Browse our range of precision tools for all your cutting needs.",
    keyword: "timco cutting",
  },
  "TIMco-Drilling-and-Driver-Bits": {
    title:
      "Discover High-Quality TIMco Drilling and Driver Bits at W-Hanson UK",
    description:
      "Explore a wide range of TIMco drilling and driver bits at W-Hanson UK. Find durable tools designed for precision and efficiency.",
    keyword: "",
  },
  "TIMco-Misc": {
    title: "High-Quality TIMco Miscellaneous Products at W-Hanson UK",
    description:
      "Explore a wide range of TIMco miscellaneous products at W-Hanson UK. Discover top-notch quality and competitive prices for all your construction needs.",
    keyword: "",
  },
  "Drywall-Products": {
    title: "Discover Quality Drywall Products at W-Hanson UK",
    description:
      "Explore a wide range of drywall products at W-Hanson UK. From plasterboards to insulation solutions, find everything you need for your construction projects.",
    keyword: "Drywall Products",
  },
  "Plasterboard": {
    title: "Quality Plasterboard Solutions for Reliable Construction Projects",
    description:
      "Explore high-quality plasterboard products at W-Hanson UK. Enhance your construction with durable materials trusted by professionals.",
    keyword: "Plasterboard",
  },
  "Plaster": {
    title: "High-Quality Thistle Plaster Products | W-Hanson UK",
    description:
      "Discover top-notch Thistle hardwall plaster and Thistle Multi Finish Plaster at W-Hanson UK. Explore our range for superior plastering solutions.",
    keyword: "thistle hardwall plaster,Thistle Multi Finish Plaster",
  },
  "Concrete-Products": {
    title: "High-Quality Concrete Products for Every Construction Need",
    description:
      "Discover a wide range of concrete products at W-Hanson UK. From foundations to finishing touches, find the perfect solution for your construction projects.",
    keyword: "",
  },
  "Pre-Stressed-Lintels": {
    title: "High-Quality Pre-Stressed Lintels at W-Hanson UK",
    description:
      "Discover durable pre-stressed lintels at W-Hanson UK. Explore our range designed for strength and reliability. Order yours today!",
    keyword: "",
  },
  "Copings": {
    title: "High-Quality Concrete Coping Stone & Lintels | W-Hanson UK",
    description:
      "Discover durable concrete coping stone and prestressed concrete lintels at W-Hanson UK. Explore our range for your construction needs.",
    keyword: "concrete coping stone,prestressed concrete lintel",
  },
  "Pier-Caps": {
    title: "Enhance Your Property with High-Quality Pier Caps - W-Hanson UK",
    description:
      "Discover premium pier caps crafted for durability and style at W-Hanson UK. Elevate your property with our exquisite range.",
    keyword: "Concrete Pier Cap",
  },
  "Padstones": {
    title: "High-Quality Padstones Available at W-Hanson UK",
    description:
      "Discover top-notch padstones near you with W-Hanson UK, your trusted supplier for high-quality building materials.",
    keyword: "Padstones,padstones near me,padstone suppliers near me",
  },
  "Concrete-Misc": {
    title: "Get Quality Concrete Products for Varied Projects | W-Hanson UK",
    description:
      "Discover a wide range of concrete miscellanea for your construction needs at W-Hanson UK. Explore our offerings today!",
    keyword: "",
  },
  "Decking": {
    title: "Premium Decking Solutions for Your Home | W-Hanson UK",
    description:
      "Discover premium decking solutions for your home with W-Hanson UK. Enhance your outdoor space with our quality materials and expert craftsmanship.",
    keyword: "",
  },
  "Softwood-Decking": {
    title: "Quality Softwood Decking Available at W-Hanson UK",
    description:
      "Explore our range of premium softwood decking at W-Hanson UK. Choose from various styles and finishes to enhance your outdoor space.",
    keyword: "",
  },
  "Roofing": {
    title: "Buy Quality Roofing Materials at W-Hanson UK",
    description:
      "Discover a wide range of roofing materials at W-Hanson UK. Browse our selection for top-quality solutions.",
    keyword: "roofing materials",
  },
  "Steel-Lintels": {
    title:
      "High-Quality Steel Lintels for Reliable Construction | W-Hanson UK",
    description:
      "Discover durable steel lintels at W-Hanson UK. Ensure strength and longevity for your construction projects with our premium selection.",
    keyword: "",
  },
  "Lead": {
    title: "Premium Lead Products Available at W-Hanson UK",
    description:
      "Find superior lead products at W-Hanson UK, catering to various industrial needs. Trust our expertise for durable and reliable lead solutions.",
    keyword: "",
  },
  "PVC-Soffit-Fascia": {
    title: "Premium PVC Soffit and Fascia Products at W-Hanson UK",
    description:
      "Discover high-quality PVC soffit and fascia solutions at W-Hanson UK. Explore our range designed for durability and aesthetic appeal.",
    keyword: "",
  },
  "Roof-Felt": {
    title: "High-Quality Roof Felt Solutions - W-Hanson UK",
    description:
      "Discover durable and affordable roof felt solutions at W-Hanson UK. Explore our range of products designed for longevity and reliability.",
    keyword: "",
  },
  "Torch-On-Felt": {
    title: "Get High-Quality Torch-On Felt Solutions | W-Hanson UK",
    description:
      "Discover top-notch torch-on felt roofing solutions at W-Hanson UK. Reliable, durable, and expertly installed for lasting protection.",
    keyword: "",
  },
  "Cromar-Building-Products": {
    title: "Discover Quality Cromar Building Products at W-Hanson UK",
    description:
      "Explore a wide range of Cromar building products at W-Hanson UK. Find everything you need for your construction projects.",
    keyword: "",
  },
  "GRP": {
    title: "High-Quality GRP Products by W-Hanson UK - Durable Solutions",
    description:
      "Explore a wide range of GRP products at W-Hanson UK. Our durable solutions ensure reliability and performance for your projects.",
    keyword: "",
  },
  "Paint": {
    title: "Quality Paint Products and Supplies at W-Hanson UK",
    description:
      "Discover a wide selection of premium paint products and supplies at W-Hanson UK. Explore our range today for your painting needs.",
    keyword: "",
  },
  "Undercoat-Primer": {
    title: "Enhance Surface Preparation with W-Hanson UK Undercoat Primer",
    description:
      "Discover high-quality undercoat primer from W-Hanson UK. Achieve optimal surface preparation for your projects. Order now!",
    keyword: "",
  },
  "Emulsion-Vinyl-Eggshell": {
    title: "Premium Emulsion Vinyl Eggshell Paints | W-Hanson UK",
    description:
      "Discover high-quality Emulsion Vinyl Eggshell paints at W-Hanson UK. Achieve smooth finishes with our premium selection.",
    keyword: "",
  },
  "Turps-Meths-White-Spirit-Misc": {
    title: "Shop Turps, Meths, White Spirit & More at W-Hanson UK",
    description:
      "Discover a wide range of turps, meths, white spirit, and miscellaneous products at W-Hanson UK. Quality supplies for your needs.",
    keyword: "",
  },
  "Masonry-Paint": {
    title: "Quality Masonry Paint Products for Your Projects | W-Hanson UK",
    description:
      "Discover premium masonry paint solutions at W-Hanson UK. Enhance your projects with our durable and vibrant paint range.",
    keyword: "",
  },
  "Gloss": {
    title: "Discover Quality Gloss Products at W-Hanson UK",
    description:
      "Explore a wide range of high-quality gloss products at W-Hanson UK. Find durable solutions for your projects today.",
    keyword: "",
  },
  "Plumbing": {
    title: "Find Quality Plumbing Materials at W-Hanson UK",
    description:
      "Discover top-notch plumbing materials near you at W-Hanson UK. Explore our wide selection online today!",
    keyword: "plumbing materials,plumbing materials near me",
  },
  "Solvent-Waste": {
    title: "Quality Solvent Waste Plumbing Solutions by W-Hanson UK",
    description:
      "Discover top-tier solvent waste plumbing solutions at W-Hanson UK. Explore our range of products designed for efficiency and durability.",
    keyword: "",
  },
  "Rainwater": {
    title: "Quality Rainwater Plumbing Solutions by W-Hanson UK",
    description:
      "Discover expert rainwater plumbing services in the UK with W-Hanson UK. Reliable solutions for residential and commercial needs.",
    keyword: "",
  },
  "Soil": {
    title: "Expert Plumbing Solutions by W-Hanson UK",
    description:
      "Discover top-tier plumbing services in the UK by W-Hanson. Enhance your soil system with our trusted expertise. Satisfaction guaranteed!",
    keyword: "",
  },
  "Underground": {
    title: "Discover Quality Underground Plumbing Products at W-Hanson UK",
    description:
      "Explore a wide range of underground plumbing products at W-Hanson UK. Find durable solutions for your plumbing needs.",
    keyword: "",
  },
  "Push-Fit-Fittings": {
    title: "Quality Push-Fit Fittings for Efficient Plumbing Solutions",
    description:
      "Discover a wide range of push-fit fittings at W-Hanson UK. Ensure seamless plumbing installations with our reliable products.",
    keyword: "",
  },
  "Manhole-Covers-Chambers": {
    title: "High-Quality Manhole Covers and Chambers at W-Hanson UK",
    description:
      "Discover durable plumbing products at W-Hanson UK. Explore our range of manhole covers and chambers designed for reliability and longevity.",
    keyword: "",
  },
  "Brass-Compression-Fittings": {
    title: "Quality Brass Compression Fittings for Plumbing | W-Hanson UK",
    description:
      "Discover a wide range of brass compression fittings for plumbing at W-Hanson UK. Ensure quality and reliability with our products.",
    keyword: "",
  },
  "End-Feed-Fittings": {
    title: "High-Quality End Feed Fittings for Plumbing - W-Hanson UK",
    description:
      "Discover top-notch end feed fittings for plumbing projects at W-Hanson UK. Browse our range online and find the perfect fit for your needs today!",
    keyword: "",
  },
  "Plumbing-Misc": {
    title:
      "Quality Plumbing Products at W-Hanson UK - Buy Misc Plumbing Items",
    description:
      "Discover a wide selection of plumbing products at W-Hanson UK. From essential tools to miscellaneous items, find everything you need for your plumbing projects.",
    keyword: "",
  },
  "Solder-Ring-Fittings": {
    title: "Quality Solder Ring Fittings at W-Hanson UK - Buy Now",
    description:
      "Explore a wide range of solder ring fittings at W-Hanson UK. Find high-quality plumbing solutions for your projects.",
    keyword: "",
  },
  "General-Ironmongery": {
    title: "Quality General Ironmongery Products at W-Hanson UK",
    description:
      "Discover a wide range of premium general ironmongery products at W-Hanson UK. From hinges to handles, find durable solutions for your projects.",
    keyword: "",
  },
  "Locks": {
    title: "Secure Your Property with High-Quality Locks | W-Hanson UK",
    description:
      "Explore top-notch locks at W-Hanson UK. Ensure your property's security with our durable and reliable lock solutions. Discover more online today!",
    keyword: "",
  },
  "Doors": {
    title: "Quality Doors for Every Home - W-Hanson UK",
    description:
      "Discover a wide range of high-quality doors at W-Hanson UK. Enhance your home's appeal with our durable and stylish door solutions.",
    keyword: "",
  },
  "Ply-Flush-Doors": {
    title: "High-Quality Ply Flush Doors - Explore W-Hanson UK's Range",
    description:
      "Discover premium ply flush doors at W-Hanson UK. Browse our selection for durability, style, and affordability.",
    keyword: "",
  },
  "FL&B-Doors": {
    title: "Premium FL&B Doors for Your UK Home - W-Hanson UK",
    description:
      "Discover high-quality FL&B doors for homes in the UK. Explore stylish designs and durability at W-Hanson UK.",
    keyword: "",
  },
  "L&B-Doors": {
    title: "Get Premium Quality L&B Doors Available at W-Hanson UK",
    description:
      "Discover a wide selection of L&B Doors at W-Hanson UK. Explore our range for superior craftsmanship and lasting durability.",
    keyword: "",
  },
  "Door-Blanks": {
    title: "Premium Door Blanks for Reliable Security Solutions - W-Hanson UK",
    description:
      "Discover high-quality door blanks at W-Hanson UK. Ensure security with our durable and reliable options. Explore our range today!",
    keyword: "",
  },
  "Tools": {
    title: "Buy Quality Tools for Every Job - W-Hanson UK",
    description:
      "Discover a comprehensive range of high-quality tools at W-Hanson UK. From power tools to hand tools, find everything you need for your projects.",
    keyword: "",
  },
  "Dekton-Tools": {
    title: "Discover Top Dekton Tools at W-Hanson UK",
    description:
      "Explore a wide range of high-quality Dekton tools at W-Hanson UK. Find durable solutions for your projects.",
    keyword: "",
  },
  "General-Hand-Tools": {
    title: "Find Top General Hand Tools at W-Hanson UK",
    description:
      "Upgrade your toolkit with general hand tools from W-Hanson UK. Quality tools designed to meet all your project requirements.",
    keyword: "",
  },
  "Polythene": {
    title: "GetHigh-Quality Polythene DPC Solutions at W-Hanson UK",
    description:
      "Discover superior polythene DPC products at W-Hanson UK. Ensure robust damp proofing with our trusted solutions. Visit us today!",
    keyword: "",
  },
  "Tapes": {
    title: "Quality Tapes for Every Solution- W-Hanson UK",
    description:
      "Discover a wide range of high-quality tapes at W-Hanson UK. From industrial to household use, find the perfect tape for your needs.",
    keyword: "",
  },
  "Masking-Tape": {
    title: "High-Quality Masking Tape by W-Hanson UK | Buy Now!",
    description:
      "Discover premium masking tape solutions at W-Hanson UK. Ideal for professional and DIY use. Explore our range and shop online today.",
    keyword: "",
  },
  "Gaffa-Tape": {
    title: "Buy Premium Quality Gaffa Tape - W-Hanson UK",
    description:
      "Discover durable gaffa tape at W-Hanson UK. Perfect for repairs, crafts, and more. Explore our range of high-quality adhesive tapes today.",
    keyword: "",
  },
  "Low-Tack-Tape": {
    title:
      "Low Tack Tape Solutions by W-Hanson UK | Quality Adhesive Products",
    description:
      "Discover high-quality low tack tape solutions at W-Hanson UK. Explore our range of adhesive products designed for various applications.",
    keyword: "",
  },
  "Packaging-Tape": {
    title: "High-Quality Packaging Tape for Secure Shipments | W-Hanson UK",
    description:
      "Discover durable packaging tape solutions at W-Hanson UK. Ensure your parcels stay secure during transit with our reliable tape options.",
    keyword: "",
  },
  "Scrim": {
    title: "Buy Quality Scrim Products for Your Construction Needs",
    description:
      "Discover premium scrim products at W-Hanson UK. Our range ensures durability and reliability for all construction projects.",
    keyword: "",
  },
  "General-Decorating": {
    title: "Quality General Decorating Supplies at W-Hanson UK",
    description:
      "Discover a wide range of general decorating supplies at W-Hanson UK. From essentials to specialty items, find everything you need for your decorating projects.",
    keyword: "",
  },
  "Sanding": {
    title: "Quality Sanding Products for Every Surface - W-Hanson UK",
    description:
      "Discover a wide range of sanding products at W-Hanson UK. Perfect for achieving smooth finishes on various surfaces.",
    keyword: "",
  },
  "Tetrion-Filler": {
    title:
      "Buy Premium Tetrion Filler at W-Hanson UK - Ideal for Perfect Surfaces",
    description:
      "Discover high-quality Tetrion Filler at W-Hanson UK. Achieve flawless finishes on any surface with our premium products.",
    keyword: "",
  },
  "Decorating-Tools": {
    title: "Quality Decorating Tools for Every Project - W-Hanson UK",
    description:
      "Discover a wide range of high-quality decorating tools at W-Hanson UK. From brushes to rollers, find everything you need for your projects.",
    keyword: "",
  },
  "Scrapers-Blades": {
    title: "High-Quality Scrapers and Blades - W-Hanson UK",
    description:
      "Discover top-grade scrapers and blades at W-Hanson UK. Browse our range for superior performance and durability. Order now!",
    keyword: "",
  },
  "Cleaning-preperation": {
    title: "Quality Cleaning Preparation Products by W-Hanson UK",
    description:
      "Discover a wide range of cleaning preparation solutions at W-Hanson UK. Ensure top-quality results with our trusted products.",
    keyword: "",
  },
  "Curtis-Holt-Loctite": {
    title: "High-Quality Loctite Products at W-Hanson UK",
    description:
      "Explore a wide range of superior Loctite products at W-Hanson UK. Discover solutions tailored for every need at competitive prices.",
    keyword: "",
  },
  "Hilton-Banks": {
    title: "Quality Hilton Banks by W-Hanson UK | Buy Now",
    description:
      "Discover top-notch Hilton Banks at W-Hanson UK. Explore our range and make your purchase today for premium quality and reliability.",
    keyword: "",
  },
  "Tou-Pret-Fillers": {
    title: "Quality Tou-Pret Fillers by W-Hanson UK - Buy Online Today",
    description:
      "Discover top-quality Tou-Pret fillers at W-Hanson UK. Explore our range and find the perfect products for your needs. Order now!",
    keyword: "",
  },
  "Garden-Home-Maintenance": {
    title: "Buy Quality Garden Maintenance Products at W-Hanson UK",
    description:
      "Explore a wide range of garden maintenance products at W-Hanson UK. Find everything you need for your garden and home upkeep.",
    keyword: "garden maintenance products",
  },
  "Wheelbarrows": {
    title: "Shop Quality Wheelbarrows for Efficient Material Handling ",
    description:
      "Discover durable wheelbarrows designed for reliability and efficiency at W-Hanson UK. Explore our range today!",
    keyword: "",
  },
  "Brooms": {
    title: "Buy Quality Brooms for Every Cleaning Task - W-Hanson UK",
    description:
      "Discover a wide range of brooms designed for efficiency and durability at W-Hanson UK. Perfect for homes and businesses alike.",
    keyword: "",
  },
  "Shovels-Forks": {
    title: "Quality Shovels and Forks at W-Hanson UK - Explore Our Range",
    description:
      "Discover a wide selection of durable shovels and forks at W-Hanson UK. Perfect for gardening, construction, and more. Browse now.",
    keyword: "",
  },
  "Garden-Misc": {
    title: "Transform Your Garden with W-Hanson UK's Diverse Range",
    description:
      "Explore unique garden solutions at W-Hanson UK. From tools to decor, find everything you need to enhance your outdoor space today.",
    keyword: "",
  },
  "Handy-Coil": {
    title: "Buy Premium Handy Coil at W-Hanson UK - Ideal for Your Projects",
    description:
      "Explore the versatile Handy Coil at W-Hanson UK. Perfect for various applications, from DIY projects to professional use.",
    keyword: "",
  },
  "Artificial-Grass": {
    title:
      "Transform Your Outdoor Space with Premium Artificial Grass- Buy Now!",
    description:
      "Enhance your garden with realistic, low-maintenance artificial grass from W-Hanson UK. Browse our range for the perfect solution to your landscaping needs.",
    keyword: "",
  },
  "TIMco-Metalwork": {
    title: "Leading Supplier of TIMco Metalwork Solutions in the UK",
    description:
      "Explore TIMco metalwork solutions at W-Hanson UK. Find durable fasteners and hardware for your projects. Discover our range today!",
    keyword: "",
  },
  "General-Shop-Materials": {
    title: "Leading Supplier of General Shop Materials - W-Hanson UK",
    description:
      "Explore a wide range of general shop materials at W-Hanson UK. Find everything you need for your shop projects and more.",
    keyword: "",
  },
  "Saw-Blades": {
    title: "High-Performance Saw Blades for Precision Cutting | W-Hanson UK",
    description:
      "Explore our range of advanced saw blades designed for durability and efficiency at W-Hanson UK. Ideal for precise cutting tasks.",
    keyword: "",
  },
  "Cleaning-Products": {
    title: "Buy Effective Cleaning Products Online - W-Hanson UK",
    description:
      "Explore a wide range of effective cleaning products at W-Hanson UK. Find solutions for all your cleaning needs, from household to industrial use.",
    keyword: "",
  },
  "PPE": {
    title: "Personal Protective Equipment (PPE) by W-Hanson UK",
    description:
      "Explore our range of personal protective equipment (PPE) at W-Hanson UK. Find high-performance gear to keep your team safe and productive.",
    keyword: "",
  },
  "Intumescent": {
    title: "High-performance Intumescent Strip Solutions at W-Hanson UK",
    description:
      "Explore W-Hanson UK's range of intumescent strip products designed to enhance fire safety and prevent smoke penetration.",
    keyword: "",
  },
  "Misc-Shop-Products": {
    title: "Shop Miscellaneous Products Online at W-Hanson UK",
    description:
      "Explore a diverse range of miscellaneous products at W-Hanson UK. Browse now for great deals on unique items!",
    keyword: "",
  },
  "Misc-Yard-Products": {
    title: "Top Selections of Yard Products Available at W-Hanson UK",
    description:
      "Explore a wide range of yard products at W-Hanson UK. Find everything you need for your outdoor projects.",
    keyword: "",
  },
  "Veto-Security": {
    title: "Secure Your Premises with Advanced Veto Security Solutions",
    description:
      "Explore W-Hanson UK's comprehensive range of Veto Security systems for enhanced protection. Discover reliable security solutions tailored for your needs.",
    keyword: "",
  },
  "Electrical": {
    title: "Leading Electrical Solutions by W-Hanson UK",
    description:
      "Explore top-tier electrical products and services at W-Hanson UK. Discover our comprehensive range for your needs today.",
    keyword: "",
  },
  "DPC": {
    title: "Expert Waterproofing Solutions for Your Construction Needs",
    description:
      "Explore innovative DPC solutions at W-Hanson UK. Find reliable products for effective moisture control in construction projects.",
    keyword: "",
  },
  "Polythene-Rolls": {
    title: "Premium Polythene Rolls from W-Hanson UK for All Needs",
    description:
      "Get top-tier polythene rolls at W-Hanson UK. Perfect for packaging and protection, our products ensure durability and performance.",
    keyword: "",
  },

  // New

  "Ogee": {
    title: "Ogee MDF Skirting Board Price | Buy Classic Profile | London",
    description:
      "Get the best Ogee MDF skirting board price without compromising quality. 22x69mm classic profile perfect for period homes. Pre-primed, ready to paint. London delivery.",
    keywords: "traditional skirting board, period home mouldings, classic architrave profile, decorative Ogee trim",
  },

  "6mm-Pencil-Round": {
    keywords: "DIY craft trim, detailed MDF edging, furniture moulding, decorative edge trim",
    title: "6mm Pencil Round MDF Trim | Flexible Moulding for DIY & Crafts | W. Hanson",
    description: "Versatile 6mm Pencil Round MDF trim. Perfect for DIY crafts, detailed mouldings & decorative edges. Pre-primed, easy to paint & cut. Get a quote today.",
  },
  "Torus": {
    keywords: "concave skirting profile, traditional Torus moulding, classic architrave, period property skirting",
    title: "Torus MDF Skirting & Architrave | Classic Profile | Pre-Primed | W. Hanson",
    description: " Traditional Torus MDF skirting board & architrave. A classic concave profile perfect for period & modern homes. Pre-primed, high-density MDF. Get a quote.",
  },
  "CPPLC1": {
    keywords: "skirting corner block, architrave transition, chamfered plinth, door frame block",
    title: "Chamfered Plinth Block CPPLC1 | MDF Architrave Transition Block | Primed | W. Hanson",
    description: "Chamfered plinth block CPPLC1 for seamless architrave & skirting transitions. Pre-primed MDF, easy installation. Perfect for period & modern homes. Get a quote.",
  },
  "PSE-with-15x4-Groove-17mm-Flat": {
    keywords: "PSE moulding for door frames, primed MR MDF lining, architectural groove MDF",
    title: "PSE MDF with 15x4 Groove | Ploughed & Square Edge | Door Linings",
    description: "PSE MDF with 15x4mm groove for door linings & architectural details. Ploughed & square edge profile. Pre-primed & ready for installation. Trade quality.",
  },
  "BK247": {
    keywords: "BK247 skirting profile, shadow line moulding, modern architectural trim",
    title: "BK247 Stepped MDF Moulding | Decorative Profile | Primed MR MDF",
    description: "BK247 stepped MDF moulding for decorative trim & architectural details. Unique 2x5mm step design. Pre-primed MR MDF. Perfect for feature walls & panels.",
  },

  "Square-Edge": {
    keywords: "minimalist architrave, square profile MDF, clean line skirting board",
    title: "Square Edge MDF Moulding | Modern Minimalist Profile | Complete Range",
    description: "Square edge MDF moulding range - clean 90-degree profiles for contemporary interiors. Various sizes & MR MDF options. Pre-primed ready for installation. Trade quality.",
  },
  "3mm-Pencil-Round": {
    keywords: "craft MDF trim, furniture detail edging, mini pencil round beading",
    title: "3mm MDF Trim Near Me | Pencil Round Moulding | Buy Online",
    description: " Buy 3mm pencil round MDF trim for delicate detailing & fine trim work. Small rounded profile, pre-primed MR MDF. Perfect for crafts, models & furniture detailing.",
  },
  "Chamfered-&-Rounded": {
    keywords: "modern architrave profile, combination edge trim, contemporary moulding design",
    title: "Chamfered & Rounded MDF Moulding | Soft Modern Profile | Pre-Primed",
    description: "Chamfered & Rounded MDF moulding - the perfect blend of sharp angles and soft curves. Pre-primed, easy to install. Ideal for modern homes. Get quote today.",
  },
  "SP600": {
    keywords: "door panel moulding, furniture groove detail, period style trim",
    title: "SP600 MDF Moulding | Traditional Grooved Profile | Panel Moulding Range",
    description: "SP600 MDF moulding range - traditional grooved profiles for doors, panels & furniture. Various groove positions available. MR MDF pre-primed. Perfect for period & traditional design.",
  },
  "2mm-Bevel": {
    keywords: "shadow line trim, panel bevel edging, minimalist detail moulding",
    title: "2mm Bevel MDF Moulding | Subtle Detail Trim | MR MDF Available",
    description: "2mm Bevel MDF moulding for adding subtle shadow lines & detail. Perfect for paneling, furniture & decorative trim. Pre-primed & ready to install.",
  },
  "Twice-Grooved-10x4-groove-20mm-from-Top": {
    keywords: "Victorian skirting board, Edwardian MDF skirting, period property mouldings",
    title: "Twice Grooved MDF Skirting | Dual 10x4 Grooves | Traditional Profile",
    description: "Twice grooved MDF skirting with dual 10x4mm grooves 20mm down. Traditional profile for period properties. Pre-primed MR MDF. Perfect for Victorian & Edwardian homes.",
  },
  "MDF-Window-Boards": {
    keywords: "primed MDF sill board, window board replacement, internal window sill MDF",
    title: "MDF Window Boards | Buy Premium Boards Near Me | W-Hanson",
    description: "Buy premium MDF window boards in multiple profiles & sizes. Pre-primed MR MDF available. Same-day London delivery. Trade prices with bulk discounts. Order online today.",
  },
  "MDF-Door-Stop-Misc": {
    keywords: "door frame trim, architrave stop bead, primed door stop MDF",
    title: "MDF Door Stops & Miscellaneous Trim | Complete Your Project",
    description: "MDF door stops & miscellaneous trim mouldings. Complete your door installation with matching profiles. Pre-primed & ready to fit. Bulk prices for trade.",
  },
  "MDF-Linings-sets": {
    keywords: "internal door frame kits, ready-to-install door linings, grooved door lining sets",
    title: "MDF Door Lining Sets | Complete Door Frame Kits | Pre-Primed Ready",
    description: "Complete MDF door lining sets for perfect door installations. Pre-primed, grooved or standard options. Suit standard door sizes. Fast UK delivery for trade & DIY.",
  },
  "mdf-linings": {
    keywords: "complete range MDF linings UK, grooved and standard door jambs, trade supplier of door linings",
    title: "MDF Door Linings | Complete Range & Trade Prices | W-Hanson UK",
    description: "Complete range of MDF door linings in all standard sizes. Grooved & standard profiles. Pre-primed ready for installation. Trade prices with bulk discounts. Fast UK delivery.",
  },
  "MDF": {
    keywords: "",
    title: "Standard MDF Sheets | 6mm to 25mm Thickness | Sheet Materials Trade",
    description: "Order MDF board online at wholesale prices. Premium standard MDF sheets 6mm to 25mm thickness. Perfect for furniture, joinery & construction. UK delivery available.",
  },
  "Moisture-Resistant-MDF": {
    keywords: "",
    title: "Moisture Resistant MDF Sheets | MR MDF Near Me | W-Hanson",
    description: "Buy moisture resistant MDF sheets for bathrooms, kitchens & high-humidity areas. MR MDF that won't swell or warp. UK next day delivery available. Order online.",
  },
  "Hardboard": {
    keywords: "3mm hardboard panel, backing panel board, smooth hardboard sheet",
    title: "Hardboard Sheets | 3mm Standard Grade | Backing Panels & Templates",
    description: "Quality 3mm hardboard sheets for backing panels, templates & furniture making. Smooth two-side finish. Perfect for trade & DIY projects. Order sheets today.",
  },


  // Product Details meta content

  "ogee-mdf-moulding-mr-v313-primed-hR5wi": {
    keywords: "skirting board dimensions, moisture resistant Ogee, pre-primed ready to paint, buy skirting online",
    title: "22 X 69mm Ogee MDF Primed Skirting | W-Hanson",
    description: "22x69mm Ogee MDF primed skirting board. A classic profile perfect for period homes. High-density, pre-primed & ready to paint. Get a quote today.",
    altText: "22x69mm Ogee profile MDF skirting board - classic design for traditional homes",
  },
  "6mm-pencil-round-mdf-moulding-mr-v313-primed-HebNo": {
    keywords: "moisture resistant detail trim, model making trim, primed craft moulding, thin MDF beading",
    title: "6mm Pencil Round MDF Moulding | MR MDF Trim | Primed & Ready to Paint | W. Hanson",
    description: "Buy 6mm Pencil Round MR MDF moulding. Moisture-resistant, pre-primed & perfect for crafts, furniture & detailed trim. Get a trade quote today.",
    altText: "Close-up photo showing the detailed 15 X 68, 6mm Pencil Round Mdf Moulding M.R. V313 Primed",
  },
  "torus-mdf-moulding-mr-v313-primed-Eem8x": {
    keywords: "bathroom skirting board, kitchen architrave, moisture resistant mouldings, pre-primed Torus",
    title: "Torus MR MDF Moulding | Moisture Resistant & Primed | Skirting & Architrave | W. Hanson",
    description: "Torus profile MR MDF moulding. Moisture-resistant, pre-primed & perfect for period homes. Ideal for bathrooms & kitchens. Get a trade quote today.",
    altText: "Torus profile MR MDF moulding, pre-primed for skirting boards and architrave, moisture resistant.",
  },
  "cpplc1-mdf-moulding-mr-v313-primed-with-one-v-groove-and-chamfer-17mm-flat-gfYWj": {
    keywords: "architrave corner connector, primed MDF plinth, skirting join block, installation block",
    title: "CPPLC1 Chamfered Plinth Block | MDF Architrave Corner Block | Primed",
    description: "CPPLC1 chamfered plinth block for perfect skirting & architrave corners. Pre-primed MR MDF with V-groove detail. Easy installation. Trade prices available.",
    altText: "CPPLC1 MDF architrave corner block, chamfered and primed, for perfect skirting corners.",
  },
  "18-x-144-cpplc1-mdf-moulding-mr-v313-primed-with-one-v-groove-and-chamfer-17mm-flat-Rn5f5": {
    keywords: "MDF architrave transition block, skirting corner block, primed MDF plinth",
    title: "18x144mm CPPLC1 Plinth Block | Large Corner Block | MDF Primed",
    description: "18x144mm CPPLC1 plinth block for substantial skirting corners. Chamfered design with V-groove. MR MDF pre-primed. Perfect for period properties.",
    altText: "18x144mm CPPLC1 large corner plinth block in primed MDF for substantial skirting corners.",
  },
  "pse-mdf-moulding-mr-v313-primed-with-groove-17mm-down--bdZIJ": {
    keywords: "MDF for door jambs, pre-grooved lining stock, square edge with groove",
    title: "PSE MDF with Groove 17mm Down | Door Lining Material | Primed MR MDF",
    description: "PSE MDF with groove 17mm down from top. Perfect for door linings & architectural details. MR MDF pre-primed. Standard lengths available. Bulk discounts.",
    altText: "PSE MDF with groove positioned 17mm down, a primed MR MDF door lining material ready for installation.",
  },

  "18x119x5.49m-Once-Grooved-5x5-20mm-down-from-top-edge-Primed-MR-MDF-Moulding": {
    keywords: "MDF door stop moulding, single groove trim, architrave groove det",
    title: "18x119mm Once Grooved MDF | 5x5 Groove 20mm Down | Primed MR MDF",
    description: "18x119mm once grooved MDF with 5x5mm groove 20mm down. Primed MR MDF for door linings & architectural details. 5.49m lengths. Trade quality guaranteed.",
    altText: "18x119mm once grooved MDF with a 5x5mm groove 20mm down, made from primed, moisture-resistant MR MDF.",
  },
  "bk247-mdf-moulding-mr-v313-primed-stepped-2-x-5mm-down-x-26mm-across-07563": {
    keywords: "decorative wall panel trim, feature line moulding, contemporary skirting detail",
    title: "BK247 Stepped MDF Moulding | 2x5mm Step Design | MR MDF Primed",
    description: "BK247 stepped MDF moulding with unique 2x5mm step design. Creates dramatic shadow lines & architectural depth. MR MDF pre-primed. Perfect for feature detailing.",
    altText: "Close-up detail of the unique 2x5mm step design on a BK247 MDF moulding, made from primed MR MDF.",
  },
  "square-edge-mdf-moulding-mr-v313-primed-pk2vE": {
    keywords: "modern interior trim, pre-primed square edge, kitchen bathroom skirting",
    title: "Square Edge MDF Moulding | MR MDF Primed | Contemporary Profile",
    description: "Square edge MDF moulding in MR MDF pre-primed. Clean 90-degree profile for modern interiors. Perfect for skirting, architrave & contemporary detailing.",
    altText: "Square edge MDF moulding with a contemporary profile, crafted from primed and ready-to-paint MR MDF.",
  },
  "square-edged-mdf-moulding-mr-v313-primed-j7Hxg": {
    keywords: "furniture square edging, cabinet trim MDF, crisp 90-degree edge",
    title: "Square Edge MDF Moulding | Modern Clean Lines | Primed MR MDF",
    description: "Square edge MDF moulding for contemporary interiors. Crisp 90-degree edges, pre-primed MR MDF. Perfect for modern skirting, architrave & furniture. Get samples.",
    altText: "Square edge MDF moulding featuring crisp, modern lines, pre-finished in primed MR MDF.",
  },
  "3mm-pencil-round-mdf-moulding-mr-v313-primed-dKBbx": {
    keywords: "model making trim, miniature moulding, primed craft edging, small rounded trim",
    title: "3mm Pencil Round MDF | Fine Detail Trim | Primed MR MDF",
    description: "3mm pencil round MDF for delicate detailing & fine trim work. Small rounded profile, pre-primed MR MDF. Perfect for crafts, models & furniture detailing.",
    altText: "3mm Pencil Round MDF, a fine-detail trim for delicate projects, made from primed MR MDF.",
  },
  "chamfered--rounded-mdf-moulding-mr-v313-primed--OU9wi": {
    keywords: "angled and rounded edge, furniture panel moulding, wall trim detail",
    title: "Chamfered & Rounded MDF Moulding | Modern Hybrid Profile | MR MDF Primed",
    description: "Chamfered & rounded MDF moulding - modern hybrid profile. Combines sharp angle with soft rounded edge. MR MDF pre-primed. Perfect for contemporary interiors.",
    altText: "Chamfered and Rounded MDF moulding, a modern hybrid profile created from primed MR MDF.",
  },
  "chamfered--rounded-mdf-moulding-mr-v313-primed--P2jZD": {
    keywords: "elegant shadow line, luxury interior trim, architectural detail moulding",
    title: "Chamfered & Rounded MDF Moulding | Premium Hybrid Design | MR MDF Primed",
    description: "Premium chamfered & rounded MDF moulding - sophisticated hybrid profile. MR MDF pre-primed. Creates elegant shadow lines with comfortable rounded edges.",
    altText: "Premium Chamfered and Rounded MDF moulding, an elegant hybrid design for sophisticated interiors, in MR MDF.",
  },
  "sp600-grooved-10-x-4-in-centre-mdf-moulding-mr-v313-primed-countrysidegrooved-23mm-in-from-the-edge-BYqVg": {
    keywords: "symmetrical groove trim, door centre panel, balanced groove design",
    title: "SP600 MDF with Centre Groove | 10x4mm Centred Groove | Panel Moulding",
    description: "SP600 MDF with 10x4mm groove perfectly centred. Creates balanced panel designs for doors & furniture. MR MDF pre-primed. Ideal for symmetrical applications",
    altText: "SP600 MDF with a perfectly centred 10x4mm groove, designed for symmetrical panel moulding applications.",
  },
  "sp600-grooved-10-x-4-mdf-moulding-mr-v313-primed-countrysidegrooved-23mm-in-from-the-edge-L2uBr": {
    keywords: "traditional groove detail, primed MR MDF panel, wall panel design",
    title: "SP600 Grooved MDF | 10x4 Centre Groove | Decorative Panel Moulding",
    description: "SP600 grooved MDF with 10x4mm centre groove. Decorative panel moulding for doors, furniture & wall panels. Primed MR MDF. Traditional & modern applications.",
    altText: "SP600 grooved MDF with a 10x4mm centre groove, used as a decorative panel moulding for doors and walls.",
  },
  "2mm-bevel-mdf-moulding-mr-v313-primed-Es1fi": {
    keywords: "wainscoting bevel, furniture edge detail, bathroom trim bevel",
    title: "2mm Bevel MDF Moulding | MR MDF Primed | Fine Detail Trim | W. Hanson",
    description: "2mm bevel MDF moulding in MR MDF pre-primed. Fine detail trim for shadow lines & paneling. Moisture resistant for bathrooms & kitchens. Perfect for wainscoting",
    altText: "2mm Bevel MDF moulding, a fine-detail trim for wainscoting and panels, in primed MR MDF from W. Hanson.",
  },
  "twice-grooved-20mm-down-from-top-edge-mdf-skirt-mr-v313-primedcala-thames-2--10x4-groove-v7bZr": {
    keywords: "period property skirting board, dual groove skirting 20mm down, Victorian style MDF skirting",
    title: "Twice Grooved MDF Skirting Board | Cala Thames 2 Profile | MR MDF Primed",
    description: "Twice grooved MDF skirting board - Cala Thames 2 profile. Dual 10x4 grooves 20mm down. MR MDF pre-primed. Perfect for period property restoration & traditional homes.",
    altText: "Twice grooved MDF skirting board in the Cala Thames 2 profile, made from primed, moisture-resistant MR MDF.",
  },
  "22-x-325-bullnosed--rebated-window-board-mdf-moulding-mr-v313-primed-cpSFn": {
    keywords: "325mm wide window sill, bay window board MDF, rounded front edge sill",
    title: "22x325mm Bullnosed & Rebated Window Board | MR MDF Primed | Wide Sill",
    description: "22x325mm bullnosed & rebated MDF window board. Extra wide 325mm sill with rounded front edge. MR MDF pre-primed. Perfect for bay windows & wide reveals.",
    altText: "22x325mm bullnosed and rebated MDF window board, an extra-wide primed sill for bay windows.",
  },

  "22-x-310-bullnosed--rebated-window-board-mdf-moulding-mr-v313-primed-YrmZR": {
    keywords: "standard wide window board, comfortable rounded sill, quality residential window board",
    title: "22x310mm Bullnosed & Rebated Window Board | MR MDF Primed | Premium Sill",
    description: "22x310mm bullnosed & rebated MDF window board. Premium 310mm width with comfortable rounded edge. MR MDF pre-primed. Ideal for quality residential windows.",
    altText: "22x310mm bullnosed and rebated MDF window board, a premium width sill with a comfortable rounded edge.",
  },
  "22-x-350-bullnosed--rebated-window-board-mdf-moulding-mr-v313-primed-L74Ud": {
    keywords: "statement window sill board, grand window MDF board, seating area window sill",
    title: "22x350mm Bullnosed & Rebated Window Board | Extra Wide Sill | MR MDF",
    description: "22x350mm bullnosed & rebated MDF window board. Maximum 350mm width for statement windows. MR MDF pre-primed. Perfect for grand windows & seating areas.",
    altText: "22x350mm bullnosed and rebated MDF window board, the maximum width sill for statement windows.",
  },
  "22-x-144-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-cNdmv": {
    keywords: "modern slim window sill, small room window board, tongue for easy fitting",
    title: "22x144mm Nosed & Tongued Window Board | Compact Modern Sill | MR MDF",
    description: "22x144mm nosed & tongued MDF window board. Compact width for modern windows & smaller rooms. MR MDF pre-primed. Clean contemporary design with tongue for easy fitting.",
    altText: "22x144mm nosed and tongued MDF window board, a compact, modern sill design for smaller rooms.",
  },
  "22-x-169-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-g57R9": {
    keywords: "contemporary window board width, clean line window sill, easy alignment tongue",
    title: "22x169mm Nosed & Tongued Window Board | Standard Modern Sill | MR MDF",
    description: "22x169mm nosed & tongued MDF window board. Standard modern width with clean design. MR MDF pre-primed. Tongue for easy alignment during installation.",
    altText: "22x169mm nosed and tongued MDF window board, a standard modern width with clean, contemporary lines.",
  },
  "22-x-194-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-aAp8F": {
    keywords: "larger window contemporary sill, modern interior window board, substantial clean line sill",
    title: "22x194mm Nosed & Tongued Window Board | Generous Modern Sill | MR MDF",
    description: "22x194mm nosed & tongued MDF window board. Generous modern width with clean lines. MR MDF pre-primed. Perfect for larger windows in contemporary interiors.",
    altText: "22x194mm nosed and tongued MDF window board, a generous modern sill with substantial clean lines.",
  },
  "22-x-219-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-airV5": {
    keywords: "luxury modern window board, quality installation window sill, substantial contemporary look",
    title: "22x219mm Nosed & Tongued Window Board | Premium Modern Width | MR MDF",
    description: "22x219mm nosed & tongued MDF window board. Premium width for quality modern installations. MR MDF pre-primed. Substantial contemporary appearance with clean lines.",
    altText: "22x219mm nosed and tongued MDF window board, a premium modern width for quality installations.",
  },
  "22-x-244-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-IFJSl": {
    keywords: "dramatic modern window feature, wide contemporary sill board, horizontal line window sill",
    title: "22x244mm Nosed & Tongued Window Board | Extra Wide Modern Sill | MR MDF",
    description: "22x244mm nosed & tongued MDF window board. Extra wide modern design. MR MDF pre-primed. Creates substantial contemporary window features with clean lines",
    altText: "22x244mm nosed and tongued MDF window board, an extra-wide modern sill for dramatic horizontal features.",
  },
  "22-x-294-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-fwrxS": {
    keywords: "dramatic modern window feature, contemporary wide sill board, horizontal statement window sill",
    title: "22x294mm Nosed & Tongued Window Board | Ultra Wide Contemporary Sill",
    description: "22x294mm nosed & tongued MDF window board. Ultra wide contemporary design. MR MDF pre-primed. For dramatic modern windows & architectural statements.",
    altText: "22x294mm nosed and tongued MDF window board, an ultra-wide contemporary sill for architectural statements.",
  },
  "22-x-325-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-r6bYu": {
    keywords: "architectural window board, modern maximum width sill, dramatic horizontal line design",
    title: "22x325mm Nosed & Tongued Window Board | Maximum Modern Width | MR MDF",
    description: "22x325mm nosed & tongued MDF window board. Maximum width for contemporary design. MR MDF pre-primed. Creates dramatic horizontal lines in modern architecture.",
    altText: "22x325mm nosed and tongued MDF window board, the maximum modern width for dramatic horizontal lines.",
  },
  "22-x-310-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-0Zcvr": {
    keywords: "luxury contemporary installation, substantial modern window board, quality project window sill",
    title: "22x310mm Nosed & Tongued Window Board | Premium Contemporary Width",
    description: "22x310mm nosed & tongued MDF window board. Premium contemporary width. MR MDF pre-primed. Substantial modern design for quality projects & luxury installations.",
    altText: "22x310mm nosed and tongued MDF window board, a premium contemporary width for luxury installations.",
  },
  "22-x-350-nosed--tongued-window-board-mdf-moulding-mr-v313-primed-NRb5g": {
    keywords: "architectural statement window sill, modern design maximum width, horizontal plane window board",
    title: "22x350mm Nosed & Tongued Window Board | Ultimate Contemporary Width",
    description: "22x350mm nosed & tongued MDF window board. Ultimate width for contemporary architecture. MR MDF pre-primed. Creates dramatic horizontal planes in modern design.",
    altText: "22x350mm nosed and tongued MDF window board, the ultimate width for contemporary architectural design.",
  },
  "x-549m-mdf-door-stop-primed-1IEsY": {
    keywords: "prevent wall damage door stop, 5.49 metre door stop, complete door installation trim",
    title: "MDF Door Stop 5.49m | Primed Door Furniture | Complete Door Installation",
    description: "MDF door stop in 5.49m lengths. Pre-primed ready for painting. Essential for completing door installations. Prevents wall damage from door handles. Trade packs available.",
    altText: "5.49 metre length of primed MDF door stop, essential furniture for completing any door installation.",
  },

  "30-x-94-primed-mdf-linings-grooved-15x4-to-suit-single-762-x-1981-door-KtQqe": {
    keywords: "linings for 2'6 internal doors, primed MDF door jamb, standard door frame kit",
    title: "30x94mm MDF Door Lining | Grooved 15x4 | Suits 762x1981mm Door | Primed",
    description: "30x94mm MDF door lining with 15x4mm groove. Specifically designed for 762x1981mm doors. Pre-primed & ready to install. Perfect for standard internal doors.",
    altText: "30x94mm MDF door lining with a 15x4mm groove, pre-primed to suit a standard 762x1981mm internal door.",
  },
  "30-x-94-primed-mdf-linings-grooved-15x4-to-suit-single-838-x-1981-door-CJ66k": {
    keywords: "linings for 2'9 internal doors, wider door frame kit, pre-grooved MDF lining",
    title: "30x94mm MDF Door Lining | Grooved 15x4 | Suits 838x1981mm Door | Primed",
    description: "30x94mm MDF door lining with 15x4mm groove for 838x1981mm doors. Pre-primed MR MDF. Perfect for wider internal doors. Ready for immediate installation",
    altText: "30x94mm MDF door lining with a 15x4mm groove, pre-primed to suit a wider 838x1981mm internal door.",
  },
  "30-x-102-primed-mdf-linings-grooved-15x4-to-suit-single-762-x-1981-door-USJuY": {
    keywords: "wider profile door jamb, premium look door lining, heavy duty door lining",
    title: "30x102mm MDF Door Lining | Grooved 15x4 | Suits 762x1981mm Door | Primed",
    description: "30x102mm MDF door lining with 15x4mm groove for 762x1981mm doors. Wider lining for substantial appearance. Pre-primed & ready to install. Trade quality.",
    altText: "30x102mm MDF door lining with a 15x4mm groove, a wider primed lining for a 762x1981mm door.",
  },
  "30-x-106-primed-mdf-linings-grooved-15x4-to-suit-single-762-x-1981-door-qoypl": {
    keywords: "maximum width door lining, high-spec door frame, luxury internal door lining",
    title: "30x106mm MDF Door Lining | Grooved 15x4 | Suits 762x1981mm Door | Primed",
    description: "30x106mm MDF door lining with 15x4mm groove for 762x1981mm doors. Extra wide lining for premium installations. Pre-primed MR MDF. Luxury specification.",
    altText: "30x106mm MDF door lining with a 15x4mm groove, an extra wide, primed lining for a 762x1981mm door.",
  },
  "30-x-106-primed-mdf-linings-grooved-15x4-to-suit-single-838-x-1981-door-SfsT2": {
    keywords: "luxury wide door frame kit, pre-grooved for 838mm door, high-end door installation",
    title: "30x106mm MDF Door Lining | Grooved 15x4 | Suits 838x1981mm Door | Primed",
    description: "30x106mm MDF door lining with 15x4mm groove for 838x1981mm doors. Premium width with pre-formed grooves. Perfect for wider internal doors. Pre-primed ready to install.",
    altText: "30x106mm MDF door lining with a 15x4mm groove, a premium primed lining for a wider 838x1981mm door.",
  },
  "30-x-106-primed-mdf-linings-grooved-15x4-to-suit-single-915-x-1981-door-zSdrd": {
    keywords: "door lining for 3'0 doors, disabled access door frame, building regulation compliant lining",
    title: "30x106mm MDF Door Lining | Grooved 15x4 | Suits 915x1981mm Door | Accessibility",
    description: "30x106mm MDF door lining with 15x4mm groove for 915x1981mm doors. Accessibility width with premium appearance. Pre-primed MR MDF. Perfect for Part M compliance.",
    altText: "30x106mm MDF door lining with a 15x4mm groove, for accessibility width 915x1981mm doors (Part M compliant).",
  },
  "30-x-94-primed-mdf-linings-standard-to-suit-single--762-x-1981-door-cRFNP": {
    keywords: "versatile square edge lining, plain profile door frame, custom door lining",
    title: "30x94mm Standard MDF Door Lining | Suits 762x1981mm Door | Primed",
    description: "30x94mm standard MDF door lining for 762x1981mm doors. Square edge design for versatile applications. Pre-primed ready for installation. Trade quality.",
    altText: "30x94mm standard (square edge) MDF door lining, primed to suit a standard 762x1981mm door.",
  },
  "30-x-94-primed-mdf-linings-standard-to-suit-single--838-x-1981-door-k4sMe": {
    keywords: "plain profile for wider doors, UK manufactured door lining",
    title: "30x94mm Standard MDF Door Lining | Suits 838x1981mm Door | Primed",
    description: "30x94mm standard MDF door lining for 838x1981mm doors. Square edge design for wider door applications. Pre-primed & ready to install. UK manufactured.",
    altText: "30x94mm standard MDF door lining, primed to suit a wider 838x1981mm door.",
  },
  "30-x-102-primed-mdf-linings-standard-to-suit-single-762-x-1981-door-zpOKa": {
    keywords: "substantial plain door lining, custom door frame applications",
    title: "30x102mm Standard MDF Door Lining | Suits 762x1981mm Door | Primed",
    description: "30x102mm standard MDF door lining for 762x1981mm doors. Wider square edge profile for substantial appearance. Pre-primed ready for custom applications.",
    altText: "30x102mm standard MDF door lining, a wider square-edge profile primed for a 762x1981mm door.",
  },
  "30-x-102-primed-mdf-linings-standard-to-suit-single-838-x-1981-door-9mAH8": {
    keywords: "custom wider door installation, plain profile premium lining",
    title: "30x102mm Standard MDF Door Lining | Suits 838x1981mm Door | Primed",
    description: "30x102mm standard MDF door lining for 838x1981mm doors. Wider profile with square edge design. Pre-primed for custom door installations. Trade quality.",
    altText: "30x102mm standard MDF door lining, a wider square-edge profile primed for an 838x1981mm door.",
  },
  "30-x-106-primed-mdf-linings-standard-to-suit-single-762-x-1981-door-MoCaA": {
    keywords: "luxury plain door lining, custom high-spec door frame",
    title: "30x106mm Standard MDF Door Lining | Suits 762x1981mm Door | Primed",
    description: "30x106mm standard MDF door lining for 762x1981mm doors. Extra wide square edge profile for luxury applications. Pre-primed ready for custom installation.",
    altText: "30x106mm standard MDF door lining, an extra wide square-edge profile primed for a 762x1981mm door.",
  },
  "30-x-106-primed-mdf-linings-standard-to-suit-single-838-x-1981-door-SNejI": {
    keywords: "premium plain profile for wider doors, luxury specification door jamb",
    title: "30x106mm Standard MDF Door Lining | Suits 838x1981mm Door | Primed",
    description: "30x106mm standard MDF door lining for 838x1981mm doors. Extra wide square edge for premium wider doors. Pre-primed MR MDF. Luxury specification.",
    altText: "30x106mm standard MDF door lining, an extra wide square-edge profile primed for an 838x1981mm door.",
  },

  "30-x-106-primed-mdf-linings-standard-to-suit-single-915-x-1981-door-ssRyS": {
    keywords: "plain profile for 3'0 doors, standard lining for Part M compliance",
    title: "30x106mm Standard MDF Door Lining | Suits 915x1981mm Door | Primed",
    description: "30x106mm Standard MDF Door Lining | Suits 915x1981mm Door | Primed",
    altText: "30x106mm standard MDF door lining, an extra wide square-edge profile primed for a 915x1981mm door.",
  },
  "30-x-94-primed-mdf-linings-grooved-15x4-to-suit-single-686-x-1981-door-IpBF6": {
    keywords: "lining for 2'3 internal doors, cupboard door frame MDF, compact door lining with groove",
    title: "30x94mm MDF Door Lining | Grooved 15x4 | Suits 686x1981mm Door | Primed",
    description: "30x94mm MDF door lining with 15x4mm groove for 686x1981mm doors. For smaller internal doors & cupboards. Pre-primed & ready to install. Trade quality.",
    altText: "30x94mm MDF door lining with a 15x4mm groove, primed to suit a compact 686x1981mm door or cupboard.",
  },
  "30-x-94-primed-mdf-linings-standard-to-suit-single--686-x-1981-door-pBlBm": {
    keywords: "versatile lining for narrow openings, custom cupboard frame, plain profile compact lining",
    title: "30x94mm Standard MDF Door Lining | Suits 686x1981mm Door | Primed",
    description: "30x94mm standard MDF door lining for 686x1981mm doors. Square edge design for compact door applications. Pre-primed ready for custom installation.",
    altText: "30x94mm standard MDF door lining, primed to suit a compact 686x1981mm door or cupboard.",
  },
  "30-x-82-primed-mdf-linings-standard-to-suit-single-762-x-1981-door-2lWd8": {
    keywords: "contemporary slim door frame, minimalist door lining design, slim profile for standard doors",
    title: "30x82mm Standard MDF Door Lining | Suits 762x1981mm Door | Primed",
    description: "30x82mm standard MDF door lining for 762x1981mm doors. Slimmer profile for modern applications. Pre-primed ready for installation. Contemporary design",
    altText: "30x82mm standard MDF door lining, a slim modern profile primed for a standard 762x1981mm door.",
  },
  "30-x-82-primed-mdf-linings-standard-to-suit-single-838-x-1981-door-0hZx3": {
    keywords: "slim profile for 2'9 doors, architectural slim frame specification, contemporary wider door lining",
    title: "30x82mm Standard MDF Door Lining | Suits 838x1981mm Door | Primed",
    description: "30x82mm standard MDF door lining for 838x1981mm doors. Slim profile for wider contemporary doors. Pre-primed MR MDF. Modern architectural specification.",
    altText: "30x82mm standard MDF door lining, a slim modern profile primed for a wider 838x1981mm door.",
  },
  "30-x-102-primed-mdf-linings-grooved-15x4-to-suit-single-838-x-1981-door-BTPpt": {
    keywords: "premium look for wider doors, pre-grooved for 838mm openings, heavy-duty grooved lining",
    title: "30x102mm MDF Door Lining | Grooved 15x4 | Suits 838x1981mm Door | Primed",
    description: "30x102mm MDF door lining with 15x4mm groove for 838x1981mm doors. Wider grooved lining for substantial appearance. Pre-primed ready for installation",
    altText: "30x102mm MDF door lining with 15x4mm groove, a wider primed lining for an 838x1981mm door.",
  },
  "30-x-102-primed-mdf-linings-standard-to-suit-single-533-x-1981-door-2uQLa": {
    keywords: "compact door solution, lining for utility cupboards, narrow opening door frame",
    title: "30x102mm Standard MDF Door Lining | Suits 533x1981mm Door | Primed",
    description: "30x102mm standard MDF door lining for 533x1981mm doors. For very narrow door applications. Pre-primed ready for custom installation. Compact solution.",
    altText: "30x102mm standard MDF door lining, primed to suit a very narrow 533x1981mm door.",
  },
  "25mm-x-150mm-x-210m-standard-twice-primed-mdf-moulding-with-2-eased-edgeslining-material-SNSPV": {
    keywords: "eased edge lining timber, custom joinery MDF sections, primed timber alternative",
    title: "25x150mm MDF Lining Material | 2.1m Lengths | Standard Primed | Eased Edges",
    description: "25x150mm MDF lining material in 2.1m lengths. Standard profile with eased edges. Twice primed ready for use. Perfect for custom door frames & joinery",
    altText: "25x150mm MDF lining material in 2.1m lengths, standard profile with eased edges, twice primed.",
  },
  "25mm-x-119mm-x-420m-standard-twice-primed-mdf-moulding-with-2-eased-edgeslining-material-t7s2x": {
    keywords: "long length lining material, for custom door fabrication, architectural lining sections",
    title: "25x119mm MDF Lining Material | 4.2m Lengths | Standard Primed | Eased Edges",
    description: "25x119mm MDF lining material in 4.2m lengths. Standard profile with eased edges. Twice primed ready for custom joinery. Perfect for door frames & architectural work.",
    altText: "25x119mm MDF lining material in 4.2m lengths, a standard primed profile with eased edges.",
  },
  "25mm-x-114mm-x-420m-standard-twice-primed-mdf-moulding-with-2-eased-edgeslining-material-TXPKE": {
    keywords: "versatile joinery stock, door frame and architrave stock, ready-to-use MDF sections",
    title: "25x114mm MDF Lining Material | 4.2m Lengths | Standard Primed | Eased Edges",
    description: "25x114mm MDF lining material in 4.2m lengths. Standard profile with eased edges. Twice primed ready for custom joinery. Ideal for door frames & architectural details.",
    altText: "25x114mm MDF lining material in 4.2m lengths, a standard primed profile with eased edges for joinery.",
  },
  "25mm-x-114mm-x-420m-grooved-twice-primed-mdf-moulding-with-2-eased-edgeslining-material-FZBFk": {
    keywords: "",
    title: "25x114mm Grooved MDF Lining Material | 4.2m Lengths | Primed | Eased Edges",
    description: "25x114mm grooved MDF lining material in 4.2m lengths. With hinge groove, eased edges & twice primed. Ready for custom door frame fabrication. Trade quality.",
    altText: "25x114mm grooved MDF lining material in 4.2m lengths, primed with eased edges for custom door frames.",
  },
  "25mm-x-150mm-x-420m-grooved-twice-primed-mdf-moulding-with-2-eased-edgeslining-material-tnUgS": {
    keywords: "",
    title: "25x150mm Grooved MDF Lining | Door Frame Material | MR MDF",
    description: "25x150mm grooved MDF lining material in 4.2m lengths. Twice primed with eased edges for door frames & joinery. Moisture resistant MR MDF. Trade prices.",
    altText: "25x150mm grooved MDF lining, a wider door frame material crafted from moisture-resistant MR MDF.",
  },

  "2440-x-1220-x-6mm-mdf-standard-sheet-material-wCHzq": {
    keywords: "",
    title: "6mm MDF Sheet | 2440x1220mm | Standard Grade | Sheet Materials",
    description: "6mm standard MDF sheet 2440x1220mm. Perfect for backing panels, drawer bottoms & templates. Smooth both sides. Trade quality at competitive prices. UK stocked.",
    altText: "6mm standard grade MDF sheet, 2440x1220mm, perfect for backing panels and templates.",
  },
  "2440-x-1220-x-6mm-mdf-standard-sheet-material-wCHzq": {
    keywords: "",
    title: "6mm MDF Sheet | 2440x1220mm | Standard Grade | Sheet Materials",
    description: "6mm standard MDF sheet 2440x1220mm. Perfect for backing panels, drawer bottoms & templates. Smooth both sides. Trade quality at competitive prices. UK stocked.",
    altText: "6mm standard grade MDF sheet, 2440x1220mm, perfect for backing panels and templates.",
  },
  "2440-x-1220-x-9mm-mdf-standard-sheet-material-weJv4": {
    keywords: "",
    title: "9mm MDF Sheet | 2440x1220mm | Standard Grade | Sheet Materials",
    description: "9mm standard MDF sheet 2440x1220mm. Ideal for cabinet sides, furniture components & wall paneling. Smooth finish both sides. Trade quality with bulk discounts.",
    altText: "9mm standard grade MDF sheet, 2440x1220mm, ideal for cabinet sides and furniture.",
  },
  "2440-x-1220-x-12mm-mdf-standard-caberlite-sheet-material-vyVZa": {
    keywords: "",
    title: "12mm Caberlite MDF Sheet | 2440x1220mm | Premium Smooth Finish",
    description: "12mm Caberlite MDF sheet 2440x1220mm. Ultra-smooth premium finish. Perfect for painted furniture, shelving & worktops. Superior surface quality. Trade prices.",
    altText: "12mm Caberlite MDF sheet, 2440x1220mm, featuring an ultra-smooth premium finish for painting.",
  },
  "2440-x-1220-x-25mm-mdf-standard-caberlite-sheet-material-nsTeK": {
    keywords: "",
    title: "25mm Caberlite MDF Sheet | 2440x1220mm | Extra Thick Premium Grade",
    description: "25mm Caberlite MDF sheet 2440x1220mm. Extra thick premium grade with ultra-smooth finish. Perfect for worktops, counters & heavy-duty applications. Trade quality",
    altText: "25mm Caberlite MDF sheet, 2440x1220mm, an extra thick premium grade for worktops and counters.",
  },
  "2440-x-1220-x-18mm-mdf-class-b-fr-kBypI": {
    keywords: "",
    title: "18mm Class B FR MDF | Fire Rated MDF Sheet | 2440x1220mm | Safety Compliant",
    description: "18mm Class B FR fire rated MDF sheet 2440x1220mm. Certified fire performance for commercial & safety applications. Meets building regulations. Documentation available.",
    altText: "18mm Class B FR fire rated MDF sheet, 2440x1220mm, certified for safety-compliant applications.",
  },
  "2440-x-1220-x-18mm-mdf-class-b-fire-rated-hfsCd": {
    keywords: "",
    title: "18mm Class B Fire Rated MDF | Certified Fire Resistant | 2440x1220mm",
    description: "18mm Class B fire rated MDF sheet 2440x1220mm. Independently tested fire performance. For commercial, public & safety applications. Complete certification available.",
    altText: "18mm Class B fire rated MDF sheet, 2440x1220mm, certified fire resistant for commercial use.",
  },
  "2440-x-1220-x-9mm-mdf-moisture-resistant-v313-n0SBo": {
    keywords: "MDF for bathroom cabinet, green core MDF sheet, kitchen unit MDF 9mm",
    title: "9mm Moisture Resistant MDF | MR MDF V313 | 2440x1220mm | Sheet Materials",
    description: "9mm Moisture Resistant MDF sheet 2440x1220mm. V313 certified MR MDF with green core. Perfect for bathrooms, kitchens & humid areas. Trade quality with UK delivery.",
    altText: "9mm Moisture Resistant MDF sheet, V313 certified with green core, 2440x1220mm.",
  },
  "2440-x-1220-x-12mm-mdf-moisture-resistant-v313-sheet-material-JEciL": {
    keywords: "kitchen unit material MDF, bathroom furniture sheet, premium MR MDF 12mm",
    title: "12mm Moisture Resistant MDF | MR MDF V313 | 2440x1220mm | Premium Sheet",
    description: "12mm Moisture Resistant MDF sheet 2440x1220mm. V313 certified with green core. Ideal for kitchen units, bathroom furniture & humid areas. Premium quality guaranteed.",
    altText: "12mm Moisture Resistant MDF sheet, V313 certified premium grade, 2440x1220mm.",
  },
  "2440-x-1220-x-18mm-mdf-moisture-resistant-v313-sheet-material-mXyU9": {
    keywords: "kitchen door MDF 18mm, bathroom panel sheet, commercial humid area MDF",
    title: "18mm Moisture Resistant MDF Sheet | MR MDF Near Me | V313 Certified",
    description: "18mm Moisture Resistant MDF sheet 2440x1220mm. V313 certified - our most popular MR thickness. For kitchen doors, bathroom units & commercial humid areas. Order online.",
    altText: "18mm Moisture Resistant MDF sheet, V313 certified, the most popular thickness for kitchens and bathrooms.",
  },
  "2440-x-1220-x-25mm-mdf-moisture-resistant-v313-sheet-material-HTGBk": {
    keywords: "worktop MR MDF, countertop sheet material, structural MDF for bathrooms",
    title: "25mm Moisture Resistant MDF | MR MDF V313 | 2440x1220mm | Extra Thick",
    description: "25mm Moisture Resistant MDF sheet 2440x1220mm. Extra thick V313 certified MR MDF. For heavy-duty worktops, counters & structural applications in humid areas.",
    altText: "25mm Moisture Resistant MDF sheet, V313 certified extra thick, 2440x1220mm for heavy-duty use.",
  },
  "2440-x-1220-x-30mm-mdf-moisture-resistant-v313-MlyyI": {
    keywords: "heavy-duty countertop MDF, workbench material, thick MDF for wet areas",
    title: "30mm Moisture Resistant MDF | MR MDF V313 | 2440x1220mm | Maximum Thickness",
    description: "30mm Moisture Resistant MDF sheet 2440x1220mm. Maximum thickness V313 certified MR MDF. For heavy-duty countertops, workbenches & structural humid applications.",
    altText: "30mm Moisture Resistant MDF sheet, V313 certified maximum thickness, 2440x1220mm.",
  },
  "3050-x-1220-x-30mm-caberwood-trade-mdf-moisture-resistant-v313-5i7kn": {
    keywords: "commercial MR MDF sheet, industrial length MDF, 3050mm MDF board",
    title: "3050x1220x30mm Caberwood MR MDF | Extra Long Sheet | V313 Certified",
    description: "3050x1220x30mm Caberwood Trade MR MDF sheet. Extra long 10ft sheet with moisture resistance. Premium grade for commercial & industrial humid applications.",
    altText: "3050x1220x30mm Caberwood Trade MR MDF, an extra long 10ft sheet, V313 certified.",
  },
  "2440-x-1220-x-3mm-hardboard-pefc16-37-1746-aDMxw": {
    keywords: "furniture back board, template material, smooth two-side hardboard",
    title: "3mm Hardboard Sheet | 2440x1220mm | Smooth Two-Side | PEFC Certified",
    description: "3mm hardboard sheet 2440x1220mm. Smooth both sides, PEFC certified. Perfect for backing panels, templates & furniture. Economical & reliable. Order sheets today",
    altText: "3mm hardboard sheet, 2440x1220mm, smooth on both sides and PEFC certified.",
  },
  "bulk-bag-sharp-washed-sand-lvFqA": {
    keywords: "concrete sharp sand, screeding sand, block paving sand bulk bag",
    title: "Bulk Bag Sharp Washed Sand | Building Sand Delivery | 850kg",
    description: " Premium washed sharp sand ideal for strong concrete, screeding, and rendering. Delivered in sturdy 850kg bulk bags. London & UK delivery. Order building sand online.",
    altText: "850kg bulk bag of sharp washed building sand, delivered for concrete and construction projects.",
  },
  "bulk-bag-top-soil-UdXgF": {
    keywords: "landscaping topsoil, garden soil bulk bag, weed-free topsoil",
    title: "Bulk Bag Top Soil | Premium Quality Topsoil | 850kg Bulk Bag Delivery",
    description: "Premium quality bulk bag top soil for landscaping & gardening. 850kg bulk bag delivery across London & UK. Screened & weed-free. Trade & domestic supply.",
    altText: "850kg bulk bag of premium quality topsoil for landscaping and gardening projects.",
  },
  "24m-100-x-200-new-railway-sleeper---brown-treated-uc4-YVfAd": {
    keywords: "garden retaining wall sleepers, raised bed railway sleeper, pressure treated outdoor timber",
    title: "2.4m 100x200mm Brown Treated Railway Sleepers | New Sleepers UC4",
    description: "2.4m 100x200mm new railway sleepers brown treated UC4. Perfect for landscaping, retaining walls & garden projects. Pressure treated for long life.",
    altText: "2.4m new brown treated railway sleeper, 100x200mm, UC4 pressure treated for landscaping.",
  },
  "c40-ready-mixed-concrete-40n-TxCgF": {
    keywords: "foundations concrete C40, driveway concrete mix, structural concrete 40 Newton",
    title: "C40 Ready Mixed Concrete | 40N Strength | Concrete Delivery",
    description: "C40 ready mixed concrete 40N strength for construction projects. Reliable concrete delivery service. Perfect for foundations, driveways & structural work.",
    altText: "C40 ready mixed concrete, 40N strength, available for delivery to construction sites.",
  },
  "bulk-bag-20mm-shingle-aw9TD": {
    keywords: "driveway gravel 20mm, garden shingle for drainage, 850kg bag of pebbles",
    title: "Bulk Bag 20mm Shingle | Decorative Aggregate | 850kg Bulk Bag",
    description: "Bulk bag 20mm shingle for landscaping & drainage. 850kg bulk bag delivery. Decorative aggregate for driveways, paths & garden features. Various colours available.",
    altText: "850kg bulk bag of 20mm decorative shingle for driveways, paths, and garden features.",
  },
  "concrete-t-beam-150-x-110--x-3600-3rs1m": {
    keywords: "foundation beam concrete, support beam for construction, pre-cast concrete lintel",
    title: "Concrete T-Beam 150x110x3600mm | Structural Concrete Beams",
    description: "Concrete T-beam 150x110x3600mm for structural applications. Perfect for lintels, beams & structural support. High strength concrete construction.",
    altText: "Concrete T-beam measuring 150x110x3600mm for structural lintels, beams, and support.",
  },
  "21-x-21-24m-pine-cushion-corner----cheshire-mouldings-kCeE3": {
    keywords: "furniture corner trim, rounded pine edging, decorative wood corner beading",
    title: "21x21mm Pine Cushion Corner | 2.4m Length | Cheshire Mouldings",
    description: "21x21mm pine cushion corner moulding 2.4m length. Soft rounded corner profile for furniture & joinery. Quality pine timber. Various lengths available.",
    altText: "21x21mm pine cushion corner moulding, 2.4m length, a soft rounded profile from Cheshire Mouldings.",
  },
  "2400-x-1200-x-125mm-moisture-resistant-tedged-plasterboard-LXoqc": {
    keywords: "damp resistant plasterboard, kitchen ceiling board, tapered edge plasterboard",
    title: "2400x1200x12.5mm Moisture Resistant Plasterboard | Taped & Edged",
    description: "2400x1200x12.5mm moisture resistant plasterboard taped & edged. Perfect for bathrooms, kitchens & high humidity areas. MR plasterboard for damp protection.",
    altText: "2400x1200x12.5mm moisture resistant plasterboard, taped and edged for bathrooms and kitchens.",
  },
  "bulk-bag-of-mot-type-1-xI0Zr": {
    keywords: "hardcore for foundations, certified Type 1 sub-base, 850kg aggregate bulk bag",
    title: "Bulk Bag MOT Type 1 | Sub Base Material | 850kg Bulk Bag",
    description: "Bulk bag MOT Type 1 sub base material. 850kg bulk bag delivery. Perfect for driveways, paths & foundations. Certified MOT Type 1 for construction projects.",
    altText: "850kg bulk bag of MOT Type 1 certified sub-base material for driveways and foundations.",
  },
  "2400-x-1200-x-125mm-sq-edged-plasterboard-vCrzy": {
    keywords: "drylining plasterboard, gypsum board sheet, general purpose plasterboard",
    title: "2400x1200x12.5mm Square Edged Plasterboard | Standard Plasterboard",
    description: "2400x1200x12.5mm square edged plasterboard for walls & ceilings. Standard plasterboard for general construction. Various thicknesses available. Trade prices.",
    altText: "2400x1200x12.5mm square edged plasterboard, a standard board for walls and ceilings.",
  },
  "bulk-bag-20mm-ballast-sktGl": {
    keywords: "ballast for concrete mixing, sharp sand and gravel mix, foundations ballast",
    title: "Bulk Bag 20mm Ballast | Concrete Ballast | 850kg Bulk Bag",
    description: "Bulk bag 20mm ballast for concrete mixing. 850kg bulk bag delivery. Perfect for concrete foundations, driveways & structural concrete work. Trade quality.",
    altText: "850kg bulk bag of 20mm ballast for mixing concrete for foundations and driveways.",
  },
  "24m-125-x-250-new-railway-sleeper---brown-treated-uc4-conyt": {
    keywords: "large garden sleepers for steps, heavy-duty retaining wall timber, landscaping feature sleepers",
    title: "2.4m 125x250mm Brown Treated Railway Sleepers | Large Sleepers UC4",
    description: "2.4m 125x250mm new railway sleepers brown treated UC4. Larger size for substantial landscaping projects. Pressure treated for outdoor durability.",
    altText: "2.4m new brown treated railway sleeper, 125x250mm large size, UC4 treated for substantial projects.",
  },

  "bond-it-ad-floor-plus-exterior-flexible-floor-compound-20kg-grey-nwOOt": {
    keywords: "waterproof floor leveller, outdoor floor screed, grey flexible floor compound",
    title: "Bond It AD Floor Plus Exterior Flexible Floor Compound | 20kg Grey",
    description: "Bond It AD Floor Plus exterior flexible floor compound 20kg grey. Self-leveling compound for exterior use. Flexible & waterproof for outdoor applications.",
    altText: "Bond It AD Floor Plus exterior flexible floor compound, 20kg grey, for outdoor self-levelling.",
  },
  "21-x-9-x-24m-pine-double-astragal----cheshire-mouldings-H7PBu": {
    keywords: "traditional door bead moulding, period style pine trim, decorative double bead profile",
    title: "21x9mm Pine Double Astragal | 2.4m Length | Cheshire Mouldings",
    description: "21x9mm pine double astragal moulding 2.4m length. Traditional double bead profile for doors & furniture. Quality pine timber. Perfect for period styling.",
    altText: "21x9mm pine double astragal moulding, 2.4m length, a traditional bead profile from Cheshire Mouldings.",
  },
  "215mm-ytong-standard-blocks-36n-32pp-CpUBi": {
    keywords: "lightweight building blocks, insulating concrete blocks, aircrete blocks for walls",
    title: "215mm Ytong Standard Blocks | 3.6N Strength | 32 Per Pallet",
    description: "215mm Ytong standard blocks 3.6N strength. Aerated concrete blocks for thermal insulation. 32 blocks per pallet. Lightweight & easy to work with.",
    altText: "215mm Ytong standard aerated concrete blocks, 3.6N strength, supplied 32 blocks per pallet.",
  },
  "1800-x-900-x-125mm-sq-edged-plasterboard-firecheck-W5eR8": {
    keywords: "fire rated gypsum board, 30 minute fire protection board, fire safety plasterboard",
    title: "1800x900x12.5mm Firecheck Plasterboard | Fire Resistant Board",
    description: "1800x900x12.5mm firecheck plasterboard square edged. Fire resistant plasterboard for safety applications. Various sizes available. Certified fire protection.",
    altText: "1800x900x12.5mm firecheck plasterboard, a square edged fire resistant board for safety.",
  },
  "34-x-12-x-24m-pine-double-astragal----cheshire-mouldings-pDklq": {
    keywords: "heavy duty door bead, large profile period moulding, thick double bead for furniture",
    title: " Larger Double Astragal",
    description: "34x12mm Pine Double Astragal | 2.4m Length | Cheshire Mouldings",
    altText: "A larger size double astragal decorative wood moulding.",
  },
  "2440-x-1220-x-18mm-mdf-standard-sheet-material-bJIWe": {
    keywords: "cabinet making MDF sheet, smooth MDF board 18mm, most popular MDF thickness",
    title: "2440x1220x18mm Standard MDF Sheet | MDF Sheet Material",
    description: "2440x1220x18mm standard MDF sheet for joinery & furniture. Smooth both sides ready for finishing. Most popular thickness for cabinets & construction.",
    altText: "2440x1220x18mm standard MDF sheet, a popular thickness for joinery and furniture making.",
  },
  "2440-x-1220-x-18mm-sterling-or-equiv-osb-bba-approved-osb3-sheet-material-jSxsD": {
    keywords: "oriented strand board OSB3, roofing and flooring sheet, structural sheathing board",
    title: "2440x1220x18mm OSB Board | OSB3 BBA Approved | Sterling Board",
    description: "2440x1220x18mm OSB board BBA approved OSB3. Sterling board for roofing, flooring & structural applications. Moisture resistant OSB3 for construction.",
    altText: "2440x1220x18mm OSB board, OSB3 BBA approved Sterling board for roofing and flooring.",
  },

}

export default metaConfig
